const serverUrl = 'https://oakparklab-api.ocllis.com/';

export const environment = {
  production: true,
  aiEnabled: false,
  cryptoPassphrase: '42b9b632-b845-4f0c-8c2f-ab886466da8c',
  frontendUrl: 'https://oakparklab.ocllis.com /',
  fusionAuth: {
    apiUrl: 'https://authprovider.ocllis.com/api',
    applicationId: 'dc154fc4-f16b-4b8f-b24d-fee58096fe26',
    apiKey: 'qPfq_1AYAw_DzY-3biZIBMk_Z1tszU-tF0Kd18E_rRk',
    tenantId: 'aa4778e7-dada-dddd-8b27-eac4c095feff',
  },
  portalBackend: {
    serverUrl,
    apiUrl: `${serverUrl}api`,
  },
  aiAnalysis: {
    enabled: false,
    apiUrl: 'https://portal-analyzer.ocllis.com',
    enabledRoles: ['*']
  },
  aiCommands: {
    enabled: false,
    areas: ['missing-info'],
    apiUrl: 'https://portal-voice-analyzer.ocllis.com'
  },
  resultExport: false,
  sentry: {
    dns: 'https://f8a2e380de96444fa6b36c365cf79eec@o430462.ingest.sentry.io/5440506',
  },
  allowCreateRequisitionWithMissingBillingInfo: true,
  allowCreateRequisitionWithMissingDiagnoses: true,
  allowCreateRequisitionWithMissingSignature: true,
  alternativeRequisitionForm: false,
};
